"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteManualCommitmentBodyToJSON = exports.DeleteManualCommitmentBodyFromJSONTyped = exports.DeleteManualCommitmentBodyFromJSON = void 0;
function DeleteManualCommitmentBodyFromJSON(json) {
    return DeleteManualCommitmentBodyFromJSONTyped(json, false);
}
exports.DeleteManualCommitmentBodyFromJSON = DeleteManualCommitmentBodyFromJSON;
function DeleteManualCommitmentBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
    };
}
exports.DeleteManualCommitmentBodyFromJSONTyped = DeleteManualCommitmentBodyFromJSONTyped;
function DeleteManualCommitmentBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
    };
}
exports.DeleteManualCommitmentBodyToJSON = DeleteManualCommitmentBodyToJSON;
